import React, { useEffect, useState, Suspense } from "react";
import { useSelector } from "react-redux";

import useQuotePopup from "../../../../hooks/useQuotePopup";
import LoadingOverlay from "../../../../components/LoadingOverlay";

const QuotePopup = React.lazy(() => import("./QuotePopup"));

const LazyQuotePopup = () => {
    const {
        opened,
        closeQuotePopup,
        openQuotePopup,
        requestLoadQuotePopup,
    } = useQuotePopup();
    const [isDelayedOpenQuotePopup, setIsDelayedOpenQuotePopup] = useState(false);
    const { isLoadRequested, isLoadSuccess } = useSelector(
        state => state.HomeInsurance.lazyComponents.quotePopup
    );
    useEffect(() => {
        if (opened && !isLoadRequested) {
            setIsDelayedOpenQuotePopup(true);
            closeQuotePopup();
            requestLoadQuotePopup();
        }
    }, [opened, isLoadRequested, closeQuotePopup, requestLoadQuotePopup]);
    useEffect(() => {
        if (isLoadSuccess && isDelayedOpenQuotePopup) {
            openQuotePopup();
        }
    }, [isDelayedOpenQuotePopup, isLoadSuccess, openQuotePopup]);
    return (
        isLoadRequested && (
            <Suspense fallback={<LoadingOverlay></LoadingOverlay>}>
                <QuotePopup></QuotePopup>
            </Suspense>
        )
    );
};

export default LazyQuotePopup;
